import { Typography, makeStyles } from '@material-ui/core'
import React from 'react'
import { colors } from 'theme'

const GetNotifiedText = ({ subscribed }) => {
  const classes = useStyles()

  return (
    <>
      <Typography className={classes.getNotifiedText} variant="h4">
        What happens next?{' '}
        {!subscribed ? 'Get notified.' : "We'll let you know!"}
      </Typography>
      <p>
        We&rsquo;re collecting user feedback to determine whether to publish a
        Study Guide on this title.{' '}
        {!subscribed
          ? "We'd be happy to let you know if and when it becomes available — just share your email address below."
          : "We'll send you an email if and when it becomes available!"}
      </p>
    </>
  )
}

const useStyles = makeStyles(theme => ({
  getNotifiedText: {
    color: colors.gray800,
    padding: theme.spacing(2, 0, 1, 0),
    fontSize: '1.5rem',
    fontWeight: 400,
  },
}))

export default GetNotifiedText
